// extracted by mini-css-extract-plugin
export default {"navItem":"SongsPageNavigationItem_navItem__AzxU3","active":"SongsPageNavigationItem_active__lHjJM","navLink":"SongsPageNavigationItem_navLink__vemBP"};